import { S3Client } from "@aws-sdk/client-s3";

const minioClient = new S3Client({
  endpoint: `https://${process.env.REACT_APP_MINIO_ENDPOINT}`,
  region: "us-east-1", // required by S3 SDK, value doesn't matter for MinIO
  credentials: {
    accessKeyId: process.env.REACT_APP_MINIO_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_MINIO_SECRET_KEY,
  },
  forcePathStyle: true, // required for MinIO
});

export const BUCKET_NAME = process.env.REACT_APP_MINIO_BUCKET_NAME;

export default minioClient;